<!-- =========================================================================================
  File Name: App.vue
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
    <v-tour name="proofTour" :steps="proofTourSteps"></v-tour>
    <v-tour name="ypaHowToStartTour" :steps="ypaHowToStartSteps" :options="{ labels: { buttonSkip: 'End Walkthrough', buttonPrevious: 'Previous', buttonNext: 'Next', buttonStop: 'Finish' }}" ></v-tour>
    <v-tour name="ypaProjectInformationTour" :steps="ypaProjectInformationSteps" :options="{ labels: { buttonSkip: 'End Walkthrough', buttonPrevious: 'Previous', buttonNext: 'Next', buttonStop: 'Finish' }}"></v-tour>
    <v-tour name="whereDoIStartYPATour" :steps="whereDoIStartYPASteps" :options="{ labels: { buttonSkip: 'End Walkthrough', buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartAccountTour" :steps="whereDoIStartAccountSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartUserTour" :steps="whereDoIStartUserSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartProofTour" :steps="whereDoIStartProofSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOrderTour" :steps="whereDoIStartOrderSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOnlineSalesTour" :steps="whereDoIStartOnlineSalesSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOnlineSalesSetupTour" :steps="whereDoIStartOnlineSalesSetupSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartProofTourSchool" :steps="whereDoIStartProofTourSchoolSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOrderTourSchool" :steps="whereDoIStartOrderTourSchoolSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOnlineSalesTourSchool" :steps="whereDoIStartOnlineSalesTourSchoolSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartOnlineSalesSetupTourSchool" :steps="whereDoIStartOnlineSalesSetupTourSchoolSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartSoftware" :steps="whereDoIStartSoftwareSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="whereDoIStartSoftwareSchool" :steps="whereDoIStartSoftwareSchoolSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
    <v-tour name="productSetupPricing" :steps="productSetupPricingSteps" :options="{ labels: { buttonStop: 'Close' }}"></v-tour>
  </div>
</template>

<style>
.BeaconContainer {
  z-index: 100000 !important;
}
.blob {
	background: #5A107C;
	border-radius: 50%;
	height: 20px;
	width: 20px;

	box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
	transform: scale(1);
	animation: pulse 2s infinite;
  display: inline-block;
}
.ui-helper-hidden-accessible {
  display: none;
}

@keyframes pulse {
	0% {
		transform: scale(1);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(1);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
}
.v-step {
  background-color: #492969 !important;
  max-width: 435px !important;
  z-index: 1000000 !important;
}
.vs-dialog {
  min-width: 650px !important;
}
</style>

<script>
import { mapGetters } from 'vuex'
import themeConfig from '@/../themeConfig.js'

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  computed: {
    ...mapGetters([
      'proofTourSteps',
      'ypaHowToStartSteps',
      'whereDoIStartYPASteps',
      'whereDoIStartAccountSteps',
      'whereDoIStartUserSteps',
      'whereDoIStartProofSteps',
      'whereDoIStartOrderSteps',
      'whereDoIStartOnlineSalesSteps',
      'whereDoIStartOnlineSalesSetupSteps',
      'whereDoIStartProofTourSchoolSteps',
      'whereDoIStartOrderTourSchoolSteps',
      'whereDoIStartOnlineSalesTourSchoolSteps',
      'whereDoIStartOnlineSalesSetupTourSchoolSteps',
      'whereDoIStartSoftwareSteps',
      'whereDoIStartSoftwareSchoolSteps',
      'ypaProjectInformationSteps',
      'productSetupPricingSteps'
    ])
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
